export function dataInRequest(params = {}) {
  return {
    type: '@msgtcaPostoLoco/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@msgtcaPostoLoco/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@msgtcaPostoLoco/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@msgtcaPostoLoco/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@msgtcaPostoLoco/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@msgtcaPostoLoco/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@msgtcaPostoLoco/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@msgtcaPostoLoco/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@msgtcaPostoLoco/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@msgtcaPostoLoco/RECORD_FILTERING',
    payload: { params },
  };
}
